export default __webpack_public_path__ + "static/media/AE22.7290450d.jpg";